import React from 'react';

const VARIANT_CLASSES = {
  light: {
    success: 'bg-emerald-50 text-emerald-700 border-emerald-200',
    info: 'bg-blue-50 text-blue-700 border-blue-200',
    warning: 'bg-amber-50 text-amber-700 border-amber-200',
    danger: 'bg-red-50 text-red-700 border-red-200',
    neutral: 'bg-slate-100 text-slate-600 border-slate-200',
    brand: 'bg-themePrimary/10 text-themePrimary border-themePrimary/20',
  },
  dark: {
    success: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20',
    info: 'bg-blue-500/10 text-blue-400 border-blue-500/20',
    warning: 'bg-amber-500/10 text-amber-400 border-amber-500/20',
    danger: 'bg-red-500/10 text-red-400 border-red-500/20',
    neutral: 'bg-slate-500/10 text-slate-400 border-slate-500/20',
    brand: 'bg-violet-500/10 text-violet-400 border-violet-500/20',
  },
};

// Maps the app's semantic status strings onto the 6 badge variants above —
// the single source of truth other components can reuse for status pills.
export const STATUS_VARIANT = {
  ACTIVE: 'success',
  CONNECTED: 'success',
  SUBMITTED: 'success',
  APPROVED: 'success',
  UPCOMING: 'info',
  SCHEDULED: 'info',
  IN_PROGRESS: 'info',
  WARNING: 'warning',
  TAB_SWITCH: 'warning',
  PENDING: 'warning',
  DRAFT: 'neutral',
  COMPLETED: 'neutral',
  INACTIVE: 'neutral',
  DISCONNECTED: 'danger',
  LOCKED: 'danger',
  CANCELLED: 'danger',
  FORCE_SUBMITTED: 'danger',
  DELETED: 'danger',
};

const Badge = ({ variant, tone = 'light', icon: Icon, className = '', children, ...rest }) => {
  const resolvedVariant = variant || STATUS_VARIANT[String(children).toUpperCase()] || 'neutral';
  return (
    <span
      className={[
        'inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium border whitespace-nowrap',
        (VARIANT_CLASSES[tone] || VARIANT_CLASSES.light)[resolvedVariant] || VARIANT_CLASSES[tone].neutral,
        className,
      ].join(' ')}
      {...rest}
    >
      {Icon && <Icon className="w-3 h-3" />}
      {children}
    </span>
  );
};

export default Badge;
